import React from "react";

const HeaderButton = () => {
  return (
    <>
      <div className="mx-auto">
        <a href="#about">
          <button className="see">
            Checkout Portfolio<i className="fas fa-eye"></i>
          </button>
        </a>
      </div>
    </>
  );
};

export default HeaderButton;
